import { render, staticRenderFns } from "./LoadsFeedReport.vue?vue&type=template&id=0ff7b954"
import script from "./LoadsFeedReport.vue?vue&type=script&lang=js"
export * from "./LoadsFeedReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports